/* istanbul ignore file */
import { useStanConfig } from "../contexts/StanConfigContext";

export const useStanDisplayName = (): string => {
  const { config } = useStanConfig();
  return config?.displayName || "STAN";
};
